/**
 * qa
 * @constructor
 */
class Qa {
  constructor() {
    this.hash = location.hash;
  }
  /**
   * サンプル
   */
  init() {
    if(this.hash){
      this.hashLink();
    }

    const tabs = $('.p-qa__tabItem');
    $('.p-qa__tabItem').on("click", function() {
      $('.active').removeClass('active');
      $(this).addClass('active');
      const index = tabs.index(this);
      $('.p-qa__tabContent').removeClass('show').eq(index).addClass('show');
    })

    const trigger = $('.p-qa__tabContentBlockQuestion')
    trigger.on('click', function () {
      $(this).next().stop().slideToggle(300);
      $(this).toggleClass('is-active');
      if($(this).hasClass('is-active')) {
        $(this).children('span').html('CLOSE');
      } else {
        $(this).children('span').html('OPEN');
      }
    })
  }
  hashLink(){
    console.log(this.hash)

    if(
      this.hash == '#alphapremium' ||
      this.hash == '#alphadrink' ||
      this.hash == '#zerodrink' ||
      this.hash == '#golddrink2' ||
      this.hash == '#goldzerodrink'
      ){
        $('.active').removeClass('active');
        $('.p-qa__tabItem').eq(1).addClass('active');
        $('.p-qa__tabContent').removeClass('show').eq(1).addClass('show');
      }
    else if(
      this.hash == '#healing' ||
      this.hash == '#healingdrink'
      ){
      $('.active').removeClass('active');
      $('.p-qa__tabItem').eq(2).addClass('active');
      $('.p-qa__tabContent').removeClass('show').eq(2).addClass('show');
    }
    else if(
      this.hash == '#iplus' ||
      this.hash == '#idrink'||
      this.hash == '#iclear_charge'
      ){
      $('.active').removeClass('active');
      $('.p-qa__tabItem').eq(3).addClass('active');
      $('.p-qa__tabContent').removeClass('show').eq(3).addClass('show');
    }
    else if(
      this.hash == '#koshitector' ||
      this.hash == '#chondroizer'
      ){
      $('.active').removeClass('active');
      $('.p-qa__tabItem').eq(4).addClass('active');
      $('.p-qa__tabContent').removeClass('show').eq(4).addClass('show');
    }
    var position = $(this.hash).offset().top;
    $('body,html').animate({scrollTop:position}, 1, 'swing');

  }
};

export default Qa;
